import resetActTeamStore from '~/store/actTeam/actions/resetActTeamStore';
import resetClientStore from '~/store/client/actions/resetClientStore';
import resetCoordinateStore from '~/store/coordinate/actions/resetCoordinateStore';
import resetNetworkStore from '~/store/network/actions/resetNetworkStore';
import resetReportsStore from '~/store/reports/actions/resetReportsStore';
import resetResourceStore from '~/store/resource/actions/resetResourceStore';
import resetSystemAlertsStore from '~/store/systemAlert/actions/resetSystemAlertsStore';
import removeAvatar from './removeAvatar';
import resetUser from './resetUser';
import setAuthorized from './setAuthorized';
import setAvatar from './setAvatar';
import setRole from './setRole';
import setUser from './setUser';

export default {
  resetUser,
  setAuthorized,
  setUser,
  setRole,
  setAvatar,
  removeAvatar,
  resetReportsStore,
  resetResourceStore,
  resetClientStore,
  resetSystemAlertsStore,
  resetCoordinateStore,
  resetActTeamStore,
  resetNetworkStore,
};
